<template>
  <Teleport to="body">
    <Modal ref="modal" v-model="show">
      <ModalContent size="xlarge">
        <template #header>
          <Heading level="h2">Instructions</Heading>
        </template>

        <div class="tw-space-y-2">
          <Heading level="h3">Selecting the stations</Heading>
          <Text tag="ul" class="tw-ml-3 tw-list-outside tw-list-disc">
            <Text tag="li"
              >Click the <Text tag="span" class="tw-font-black">“+”</Text> icon in the top menu to open the list of all
              stations.</Text
            >
            <Text tag="li">Use the checkboxes to select the stations you want to display.</Text>
            <Text tag="li"
              >Then, choose how many stations you’d like to see per row using the “Number of columns” dropdown — or
              click <Text tag="span" class="tw-font-black">Auto Align</Text> to let the system adjust the layout
              automatically based on your screen size.</Text
            >
            <Text tag="li"
              >When you’re done, click <Text tag="span" class="tw-font-black">Save to</Text> apply your selection.</Text
            >
          </Text>
        </div>

        <div class="tw-mt-6 tw-space-y-2">
          <Heading level="h3">Selecting the stations</Heading>
          <Text tag="ul" class="tw-ml-3 tw-list-outside tw-list-disc">
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">About NATE & RoboCam</Text> — Opens a website with information
              about NATE and RoboCam.</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Instructions</Text> — Opens this help window with usage
              tips.</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Double arrow icon</Text> — Lets you pin the upper menu so it stays
              visible (sticky). When the arrows point up, the bar is pinned. Click it to unpin the bar — it will then
              appear only when you hover over it, and the arrows will point down. Click again to pin it back.</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Allow control</Text> — Enables extra features for each station,
              such as starting/stopping recordings or renaming stations. Use this only if you’re sure! A system
              confirmation message will appear when you turn it on.</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Monitoring</Text> — Opens a modal window with various
              charts.</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Selecting the stations</Text> — Opens the station selection menu
              (explained above).</Text
            >
            <Text tag="li"
              ><Text tag="span" class="tw-font-black">Settings</Text> — Opens a modal window with general configuration
              options.</Text
            >
          </Text>
        </div>

        <template #footer="{ reject }">
          <Button color="transparent" outlined @click="reject">Close</Button>
        </template>
      </ModalContent>
    </Modal>
  </Teleport>
</template>
<script setup>
import { Button, Heading, Modal, ModalContent, Text } from '@slideslive/fuse-kit/vue';

const show = defineModel();
</script>
